module.exports = __webpack_public_path__ + "img/login-transportistasurbanos.6faa06d9.svg";